import type { NavigateFunction } from "react-router-dom";

// 定义 navigate 变量类型为 NavigateFunction 或 null
let navigate: NavigateFunction | null = null;

/**
 * 初始化导航方法
 * @param nav - 从 useNavigate() 获取的导航函数
 */
export const setNavigate = (nav: NavigateFunction): void => {
  navigate = nav;
};

/**
 * 获取导航方法
 * @returns NavigateFunction - 导航函数
 * @throws {Error} 如果未初始化导航方法则抛出错误
 */
export const getNavigate = (): NavigateFunction => {
  if (!navigate) {
    throw new Error(
      "Navigation method not initialized, please call the 'setNavigate' method first",
    );
  }
  return navigate;
};
